import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

type Props = {
  designId: string
}

type Frame = {
  frame_position: number
  media_file_key: string
}

type Data = {
  batch_id: string
}

type Variables = {
  frames: Frame[]
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const replaceFrameContent = async (workspaceId: number, designId: string, frames: Frame[]) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/designs/${designId}/replace_frame_content`, {
    method: 'POST',
    body: { frames },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useReplaceFrameContent = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (params) => replaceFrameContent(workspaceId, designId, params.frames),
    options,
  )
}
